import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import MenuItem from '@material-ui/core/MenuItem';
import { instanceAxios } from '../InstanceAxios';

const columns = [
  { title: 'Nome', field: 'nome' },
  { title: 'Email', field: 'email' },
  { title: 'CPF', field: 'cpf' },
  { title: 'CNPJ', field: 'cnpj' },
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

export default function StickyHeadTable(props) {
  const classes = useStyles();
  const [users, setUsers] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [countItens, setCountItens] = React.useState(0);
  const [offset, setOffset] = React.useState(0);
  const [search, setSearch] = React.useState(
    props.userSelect ? props.userSelect : ''
  );
  const [modalListOfUsers, setModalListOfUsers] = useState(false);

  useEffect(() => {
    const fetchUsernames = async () => {
      setLoading(true);
      await instanceAxios(localStorage.getItem('toobiauth'))
        .post(`/listarNomesUsuarios/offset/${offset}`, {
          searchUser: search,
        })
        .then((res) => {
          setUsers(res.data.arrayUsers);
          if (props.setArrayWithUsers) {
            props.setArrayWithUsers(res.data.arrayUsers);
          }
          setCountItens(res.data.count);
        })
        .catch((err) => {
          console.log(err);
        });
      setLoading(false);
    };

    fetchUsernames();
  }, [offset]); //eslint-disable-line

  const handleChangePage = async (event, newPage) => {
    if (newPage > page) {
      setOffset(offset + 10);
    } else {
      setOffset(offset - 10);
    }
    setPage(newPage);
  };

  const textFieldUsers = () => {
    if (props.arrayWithUsers) {
      return props.arrayWithUsers.map((option) => (
        <MenuItem key={option.id} value={option.nome}>
          {option.nome}
        </MenuItem>
      ));
    }
    return users.map((option) => (
      <MenuItem key={option.id} value={option.nome}>
        {option.nome}
      </MenuItem>
    ));
  };

  const modal = () => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={modalListOfUsers}
        onClose={() => setModalListOfUsers(false)}
      >
        {loading ? (
          <Backdrop open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          <div
            style={{
              width: '90%',
              position: 'absolute',
              top: '5%',
              left: '6%',
              height: '100%',
            }}
          >
            <div
              style={{
                backgroundColor: '#FFF',
                paddingRight: 15,
                paddingBottom: 10,
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={6} />
                <Grid item xs={6}>
                  <div align="right">
                    <TextField
                      id="busca"
                      label="Pesquise por um usuário"
                      value={search}
                      onChange={async (event) => {
                        setOffset(0);
                        setPage(0);
                        setSearch(event.target.value);
                        await instanceAxios(localStorage.getItem('toobiauth'))
                          .post(`/listarNomesUsuarios/offset/${offset}`, {
                            searchUser: event.target.value,
                          })
                          .then((res) => {
                            setUsers(res.data.arrayUsers);
                            if (props.setArrayWithUsers) {
                              props.setArrayWithUsers(res.data.arrayUsers);
                            }
                            setCountItens(res.data.count);
                          });
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      style={{ width: '70%' }}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
            <Paper className={classes.root}>
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align="center"
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.title}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users.map((row) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.code}
                          onClick={() => {
                            props.setUserSelect(row.nome);
                            if (props.setIdUsuario) props.setIdUsuario(row.id);
                            if (props.setObjUser) props.setObjUser(row);
                            setModalListOfUsers(false);
                          }}
                        >
                          {columns.map((column) => {
                            const value = row[column.field];
                            return (
                              <TableCell key={column.field} align="center">
                                {value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10]}
                component="div"
                count={countItens}
                style={{ backgroundColor: '#FFF' }}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
              />
            </Paper>
          </div>
        )}
      </Modal>
    );
  };

  return (
    <>
      {modal()}
      <TextField
        id="standard-select-currency"
        select
        SelectProps={{ open: false, onOpen: () => setModalListOfUsers(true) }}
        style={{ margin: 8, width: props.width }}
        label={`${props.label}`}
        value={props.userSelect}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          readOnly: !!props.readOnly,
        }}
        onChange={(event, value) => {}}
        error={props.error}
      >
        {textFieldUsers()}
      </TextField>
    </>
  );
}
